import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { SelectableChip } from '@aimsos/ui';

import { NOTES_FEED_QUICK_FILTERS } from '../../constants/history.js';

/** From notes chips: All, Summaries, Topics, Interpretations (CT-5724). Toggle buttons; one is on. */
const NotesFeedQuickFilters = memo(function NotesFeedQuickFilters({ value, onChange }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div role="group" aria-label={t('history.notes.quickFilters.ariaLabel')} className="flex flex-wrap items-center gap-2">
      {NOTES_FEED_QUICK_FILTERS.map((id) => (
        <SelectableChip key={id} size="m" selected={value === id} onClick={() => onChange(id)}>
          {t(`history.notes.quickFilters.${id}`)}
        </SelectableChip>
      ))}
    </div>
  );
});

export default NotesFeedQuickFilters;
